<div id="st-payment-response-popup-payment-response-overlay" class="payment-response-overlay" *ngIf="visible" (click)="onBackdropClick($event)" (keydown.enter)="onBackdropClick($any($event))" (keydown.space)="$event.preventDefault(); onBackdropClick($any($event))">
  <div id="st-payment-response-popup-ticket-wrapper" class="ticket-wrapper" [class.ticket-wrapper--failure]="isFailure" (click)="$event.stopPropagation()" (keydown.enter)="$any($event).stopPropagation()" (keydown.space)="$event.preventDefault(); $any($event).stopPropagation()">
    <div id="st-payment-response-popup-ticket-card" class="ticket-card">
      

      <div id="st-payment-response-popup-status-badge" class="status-badge" [class.status-badge--failure]="isFailure" aria-hidden="true">
        <svg *ngIf="!isFailure" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
        <svg *ngIf="isFailure" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>

      <dialog id="st-payment-response-popup-ticket-card-surface" class="ticket-card-surface" open
        [attr.aria-labelledby]="'payment-response-title'">
        <div id="st-payment-response-popup-ticket-top" class="ticket-top">
          <h2 id="payment-response-title" class="payment-title">{{ effectiveTitleKey | translate }}</h2>
          <p class="payment-subtitle">{{ effectiveSubtitleKey | translate }}</p>
        </div>

        <div id="st-payment-response-popup-ticket-perforation" class="ticket-perforation" aria-hidden="true"></div>

        <div id="st-payment-response-popup-ticket-scroll-body" class="ticket-scroll-body">
          <div id="st-payment-response-popup-ticket-bottom" class="ticket-bottom">
            <div id="st-payment-response-popup-transaction-block" class="transaction-block">
              <div id="st-payment-response-popup-transaction-label" class="transaction-label">{{ 'transaction_id' | translate }}</div>
              <div id="st-payment-response-popup-transaction-id" class="transaction-id">{{ transactionId }}</div>
            </div>

            <!-- Success: event / line items -->
            <div id="st-payment-response-popup-event-block" class="event-block" *ngIf="!isFailure && (eventTitle || detailLines.length)">
              <div id="st-payment-response-popup-event-title" class="event-title" *ngIf="eventTitle">{{ eventTitle }}</div>
              <div [id]="'st-payment-response-popup-event-item' + (line)" class="event-item" *ngFor="let line of detailLines; trackBy: trackById">
                <div id="st-payment-response-popup-green-dot" class="green-dot" aria-hidden="true">
                  <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <polyline points="1.5 5 4 7.5 8.5 2.5" />
                  </svg>
                </div>
                <span>{{ line }}</span>
              </div>
            </div>

            <!-- Failure: reason + next steps -->
            <ng-container *ngIf="isFailure">
              <div id="st-payment-response-popup-failure-info-block" class="failure-info-block">
                <div id="st-payment-response-popup-failure-info-title" class="failure-info-title">{{ 'payment_failure_reason_title' | translate }}</div>
                <ul class="failure-list">
                  <ng-container *ngIf="useI18nReason">
                    <li *ngFor="let key of failureReasonI18nKeys; trackBy: trackById">{{ key | translate }}</li>
                  </ng-container>
                  <ng-container *ngIf="!useI18nReason">
                    <li *ngFor="let line of failureReasonLines; trackBy: trackById">{{ line }}</li>
                  </ng-container>
                </ul>
              </div>

              <div id="st-payment-response-popup-failure-info-block-1" class="failure-info-block">
                <div id="st-payment-response-popup-failure-info-title-2" class="failure-info-title">{{ 'payment_failure_next_steps_title' | translate }}</div>
                <ul class="failure-list">
                  <ng-container *ngIf="useI18nNextSteps">
                    <li *ngFor="let key of failureNextStepI18nKeys; trackBy: trackById">{{ key | translate }}</li>
                  </ng-container>
                  <ng-container *ngIf="!useI18nNextSteps">
                    <li *ngFor="let line of failureNextStepLines; trackBy: trackById">{{ line }}</li>
                  </ng-container>
                  <li class="failure-list-support">
                    <span>{{ 'payment_failure_support_prefix' | translate }}</span>
                    <a [href]="supportContactHref" class="failure-inline-link">{{ 'payment_failure_contact' | translate
                      }}</a>
                    <span>{{ 'payment_failure_support_suffix' | translate }}</span>
                  </li>
                </ul>
              </div>
            </ng-container>

            <!-- Success: invoice + order history -->
            <div id="st-payment-response-popup-links-row" class="links-row" *ngIf="!isFailure">
              <button type="button" class="link-btn link-btn--pill" (click)="onViewInvoice()" (keydown.enter)="onViewInvoice()" (keydown.space)="$event.preventDefault(); onViewInvoice()" tabindex="0">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <span>{{ 'view_invoice' | translate }}</span>
              </button>
              <button type="button" class="link-btn link-btn--pill" (click)="onViewOrderHistory()" (keydown.enter)="onViewOrderHistory()" (keydown.space)="$event.preventDefault(); onViewOrderHistory()" tabindex="0">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" aria-hidden="true">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                <span>{{ 'view_order_history' | translate }}</span>
              </button>
            </div>

            <!-- Failure: order history only -->
            <div id="st-payment-response-popup-failure-links-row" class="failure-links-row" *ngIf="isFailure">
              <button type="button" class="link-btn link-btn--pill link-btn--solo" (click)="onViewOrderHistory()" (keydown.enter)="onViewOrderHistory()" (keydown.space)="$event.preventDefault(); onViewOrderHistory()" tabindex="0">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" aria-hidden="true">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                <span>{{ 'view_order_history' | translate }}</span>
              </button>
            </div>

            <div id="st-payment-response-popup-failure-actions" class="failure-actions" *ngIf="isFailure">
              <button type="button" class="back-btn back-btn--outline" (click)="onBack()" (keydown.enter)="onBack()" (keydown.space)="$event.preventDefault(); onBack()" tabindex="0">{{ 'back' | translate
                }}</button>
              <button type="button" class="back-btn back-btn--primary" (click)="onRetryPayment()" (keydown.enter)="onRetryPayment()" (keydown.space)="$event.preventDefault(); onRetryPayment()" tabindex="0">{{ 'retry_payment' |
                translate }}</button>
            </div>

            <button type="button" class="back-btn" *ngIf="!isFailure" (click)="onBack()" (keydown.enter)="onBack()" (keydown.space)="$event.preventDefault(); onBack()" tabindex="0">{{ 'back' | translate
              }}</button>
          </div>

          <div id="st-payment-response-popup-ticket-footer" class="ticket-footer" *ngIf="footerPrice || footerClosesText">
            <span class="footer-price" *ngIf="footerPrice">{{ footerPrice }}</span>
            <span class="footer-closes" *ngIf="footerClosesText">{{ footerClosesText }}</span>
          </div>
        </div>
      </dialog>
    </div>
  </div>
</div>